module.exports = __webpack_public_path__ + "static/media/dumy-recent-news-1.5e2a0a8b.png";